module.exports = __webpack_public_path__ + "static/media/perksGO_cardIcon.1047803e.svg";